import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";

const serviceURL = process.env.REACT_APP_MAIN + "/api/v1/SalesGrantor";

export const listSalesGrantors = () => {
  return GlobalAxios.get<ISelectType[]>(`${serviceURL}/list`);
};
